import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../hooks'
import { signOut } from '../../redux-toolkits/auth/auth.reducer'
import { authSelector } from '../../redux-toolkits/auth/auth.selector'
import { Avatar } from '../avatar'
import Icon from '../icon'
import Dropdown from '../inputs/dropdown'
import { Logo } from '../logo'

const TopNavigation = ({
  navOpen,
  setNavOpen,
}: {
  navOpen?: boolean
  setNavOpen?: (val: boolean) => void
}): JSX.Element => {
  const dispatch = useDispatch()

  const handleLogout = (): void => {
    dispatch(signOut())
  }

  const { user } = useAppSelector(authSelector)

  return (
    <div
      className="
      px-4 md:px-10 py-5
      flex justify-between items-center
      border-b !z-[999] w-full
      "
    >
      <div className="flex items-center gap-6">
        {user?.firstname || user?.fullName ? (
          <div className="hidden">
            <button
              onClick={() => {
                setNavOpen && setNavOpen(!navOpen)
              }}
            >
              <Icon
                id={navOpen ? 'close-icon' : 'menu-icon'}
                width={navOpen ? 20 : 30}
                height={navOpen ? 20 : 30}
                className="transition-all duration-300 flex xl:hidden"
              />
            </button>
          </div>
        ) : null}

        <Logo />
      </div>

      {user?.firstname || user?.fullName ? (
        <div
          className="
          flex items-center justify-between
          text-black gap-6
          "
        >
          <Dropdown
            menuButton={<Avatar name={`${user?.fullName ?? user.firstname}`} />}
            menuItems={[
              {
                name: (
                  <div>
                    <span className="text-base font-recoleta font-medium">{`${
                      user?.fullName ?? user.firstname
                    }`}</span>
                    <p className="text-sm text-sec-black flex justify-between items-center">
                      <span className="text-xs">{user?.email}</span>
                    </p>
                  </div>
                ),
                value: '',
              },
              {
                name: (
                  <div className="text-danger flex items-center gap-2 w-full">
                    <Icon id="logout2-icon" height={25} width={25} />
                    <span>Sign out</span>
                  </div>
                ),
                value: '',
                onClick: () => {
                  handleLogout()
                },
              },
            ]}
            position="bottom end"
          />
        </div>
      ) : undefined}
    </div>
  )
}

export default TopNavigation
